export default function Binary_tree() {
  return (
    <>
      <div class="row_binary">
        <div class="column_binary">
          <div class="container_float">
            <h2>Binary Tree :</h2>
            <br />
            <p className="binary_content">
              {" "}
              The goal of this project is to create a reservation system for a
              room. The clients are companies. <br />
              <br />
              This project has been done entirely in C code. Everything has been
              done from scratch.
              <br />
            </p>
          </div>
        </div>
        <div class="column_binary">
          <div class="container_float">
            <h2>Links :</h2>
            <br />
            <h3>
              Project code :{" "}
              <a href="https://github.com/Viktor-hash/Binary_tree_Project_c">
                Project repository
              </a>
            </h3>
          </div>
        </div>
      </div>
      <div class="footer_projects">
        <p>© Victor Perrault 2023. Currently in Hong Kong</p>
      </div>
    </>
  );
}
